/* jshint -W072 */ // TO DO: fix maxparams violation?
angular.module('leftPaneModule')
  .directive('infoPane', function () {
    return {
      restrict: 'E',
      templateUrl: '/resources/info-pane/partials/info-pane.html',
      controller: [
        '$filter',
        '$rootScope',
        '$scope',
        '$state',
        'dblAnalyticsProvider',
        'assignMode',
        'authentication',
        'configuration',
        'edxReportItemService',
        'ERROR_CODES',
        'narrativeFilter',
        'navigation',
        'edxStudentAlertsService',
        'dblProductResourcesService',
        'dblStudentLoginCardReportService',
        'settingsApi',
        '$log',
        'edxFeatureFlagService',
        'dblPrintService',
        '$compile',
        'classroomApi',
        '$window',
        '$timeout',
        'dblClassroomCodePrintService',
        function ($filter,
                  $rootScope,
                  $scope,
                  $state,
                  $analytics,
                  $assignMode,
                  $authentication,
                  configuration,
                  edxReportItemService,
                  ERROR_CODES,
                  narrativeFilter,
                  navigation,
                  studentAlertsService,
                  dblProductResourcesService,
                  dblStudentLoginCardReportService,
                  settingsApi,
                  $log,
                  edxFeatureFlagService,
                  dblPrintService,
                  $compile,
                  classroomApi,
                  $window,
                  $timeout,
                  dblClassroomCodePrintService) {

          $scope.showNewStyleAlerts = showNewStyleAlerts;
          $scope.customerCanEdit = false;
          $scope.linkButtons = [];
          $scope.studentLoginUrl = '';
          $scope.schoolCode = '';
          $scope.showCodeLine = false;

          var customer = $authentication.getCustomer();
          $scope.ssoOnly = $authentication.isSsoLoginOnly(customer);

          var editButton = {
            text: 'Edit',
            icon: 'icon-cog',
            click: onClickCog,
            analytics: false,
            analyticsEvent: '',
            analyticsCategory: ''
          };

          var parentLetterButton = {
            text: 'Family Letter',
            icon: 'icon-doc-text',
            click: onClickParentLetter,
            analytics: true,
            analyticsEvent: 'Open Family Letters Modal',
            analyticsCategory: 'Navigation'
          };

          var loginCardsButton = {
            text: 'Login Cards',
            icon: 'icon-list-alt',
            click: onClickLoginCards,
            analytics: true,
            // Preserve legacy event from 'Login Information' modal
            analyticsEvent: 'Access Resources Modal',
            analyticsCategory: 'Print Student Login Cards -- English'
          };

          var classroomCodesButton = {
            text: 'Classroom Codes',
            icon: 'icon-list-alt',
            click: onClickClassroomCodes,
            analytics: true,
            // Preserve legacy event from 'Login Information' modal
            analyticsEvent: 'Access Resources Modal',
            analyticsCategory: 'Print Classroom Codes'
          };

          function getLinkButtons(role, customerCanEdit) {
            var buttons = [];
            var roleCanEdit = true;

            switch (role) {
              case 'school':
                buttons = [parentLetterButton];
                if (!$scope.ssoOnly && edxFeatureFlagService.isClassroomLoginCodesEnabled()) {
                  buttons.unshift(classroomCodesButton);
                }
                break;
              case 'classroom':
                buttons = [parentLetterButton];
                if(!$scope.ssoOnly) { buttons.unshift(loginCardsButton); }
                break;
              case 'teacher':
              case 'student':
                buttons = [];
                break;
              default:
                roleCanEdit = false;
                buttons = [];
            }

            if (customerCanEdit && roleCanEdit) {
              buttons.push(editButton);
            }

            return buttons;
          }

          var rosterPromise;

          var authenticatedCustomer;

          // Note: studentImageUrl is set from edx-student-report.controller.js because it
          // comes off of the highlights call done there.

          $scope.schoolAdminChooserEnabled = false;

          var customerSubject = $authentication.getCustomerSubject();

          customerSubject.subscribe(
            function (customer) {
              authenticatedCustomer = customer;
              $scope.customerRole = customer.role;
              $scope.customerCanEdit = customer.getSettingsPermissions().canEdit;

              var itemType = '';
              if ($scope.item) {
                itemType = $scope.item.type;
              }

              $scope.linkButtons = getLinkButtons(itemType, $scope.customerCanEdit);
            }
          );

          /**
           * Determine if we should show a badge based on the new alerts under the EFP
           * @return {*|boolean}
           */
          function showNewStyleAlerts() {
            return $scope.item && $scope.item.type === 'student' && authenticatedCustomer && authenticatedCustomer.hasTag('INSIGHT_EFP') && configuration.isFeatureEnabled('alerts_efp_enabled');
          }

          var determineSchoolAdminChooserEnabled = function (item) {
            if (item.type === 'school' && $authentication.isSchoolAdmin(customer)) {
              if (customer.school_admin_ids) {
                if (customer.school_admin_ids.length > 1) {
                  $scope.schoolAdminChooserEnabled = true;
                } else if (customer.classroom_ids && customer.classroom_ids.length) {
                  $scope.schoolAdminChooserEnabled = true;
                }
              }
            } else if (customer.school_admin_mode === 2 && (item.type === 'classroom' || item.type === 'teacher')) {
              $scope.schoolAdminChooserEnabled = true;
            } else {
              $scope.schoolAdminChooserEnabled = false;
            }
          };

          function addSecondaryItem(secondaryItems, elementType, text, action, id) {
            secondaryItems.push({
              elementType: elementType,
              text: text,
              action: action
            });
          }

          function buildSecondaryItems(item) {
            var secondaryItems = [];

            if (item.type !== 'classroom' && item.city && item.zip) {
              addSecondaryItem(secondaryItems, false, item.city + ' ' + item.zip);
            }

            if (item.email_address) {
              addSecondaryItem(secondaryItems, 'link', item.email_address, 'mailto:' + item.email_address);
            }

            if (item.type === 'student') {
              addSecondaryItem(secondaryItems, undefined, $filter('grade')(item.grade) + ' Student');
            }

            if (item.type === 'classroom') {
              addSecondaryItem(secondaryItems, undefined, $filter('grade')(item.grade) + ' Classroom');
            }

            addSecondaryItem(secondaryItems, 'js-link', customer.academic_standard_title_in_reports + ' [edit]', function () {
              $rootScope.onModalOpenClick('standardChooserModal');
            });

            if ($scope.schoolAdminChooserEnabled) {
              addSecondaryItem(secondaryItems, 'js-link', 'Other Schools and Classrooms',  function () {
                $rootScope.$broadcast('chooseSchoolModal');
              });
            }

            $scope.secondaryItems = secondaryItems;
          }

          function navigateToSettingsForItem() {
            var itemId = $scope.item.id;
            var itemType = $scope.item.type;
            var params = _.pick($state.params, ['schoolId', 'teacherId', 'classroomId']);

            var teacherPane;
            if (itemType === 'teacher') {
              teacherPane = 'teacher_profile';
            } else if (itemType === 'classroom') {
              teacherPane = 'classroom_settings';
            } else if (itemType === 'student') {
              teacherPane = 'roster';
            }

            if (customer.isAdmin()) {
              params.pane = 'teacher_list';
              if (teacherPane) {
                params.subpane = teacherPane;
              }
            } else {
              params.pane = teacherPane;
            }

            navigation.go('manage', params);
          }

          /**
           * Loads new style alerts and sets into scope
           *
           * @param item The item loaded by framework
           * @private
           */
          function _loadStudentAlerts(item) {
            if (item.type === 'student' && showNewStyleAlerts()) {
              $scope.studentAlerts = undefined;
              $scope.alert = undefined;
              studentAlertsService.loadCurrentStudentAlertsForStudent($state.params.districtId, item.id, $state.params.ast).then(function (studentAlerts) {
                $scope.studentAlerts = studentAlertsService.flattenStudentAlerts(studentAlerts);
                var topAlert = studentAlertsService.selectPriorityAlert(studentAlerts);

                if (topAlert.alerts.length > 0) {
                  $scope.alert = topAlert.alerts[0];

                  $scope.narratives = narrativeFilter($scope.alert.type, item.type, item.first_name);
                }
              });
            }
          }

          var setNarratives = function (item) {
            $scope.narratives = '';

            _.each(item.status_reason_codes, function (code) {
              var narrative = '<p>' + narrativeFilter(code, $scope.item.type, $scope.item.first_name) + '</p>';
              $scope.narratives = $scope.narratives.concat(narrative);
            });

            $scope.warningNarrative = "";
            if (item.warn) {
              var hasLowUsage = _.indexOf(item.status_reason_codes, 'LOW_AVERAGE_SESSION_TIME') !== -1 || _.indexOf(item.status_reason_codes, 'LOW_AVERAGE_LESSONS_COMPLETED') !== -1 || _.indexOf(item.status_reason_codes, 'LOW_PERCENTAGE_ACTIVE_STUDENTS') !== -1;
              var hasMayNeedAssistance = _.indexOf(item.status_reason_codes, 'FAILED_LESSONS_THRESHOLD_REACHED') !== -1;

              if (hasLowUsage) {
                $scope.warningNarrative = 'Low Usage';
              } else if (hasMayNeedAssistance) {
                $scope.warningNarrative = 'May Need Assistance';
              }
            }
          };

          function getUrlIdentifier(item) {
            var urlIdentifier = '';
            switch (item.type) {
              case 'school':
                urlIdentifier = item.url_identifier;
                break;
              default:
                urlIdentifier = item.school_url_identifier;
            }

            return urlIdentifier;
          }

          $log.debug('Subscribing to item');
          var itemSubscription = edxReportItemService.getItemObservable().subscribe(function (item) {
            $log.debug('Receiving item');
            $scope.item = item;
            determineSchoolAdminChooserEnabled(item);
            setNarratives(item);
            buildSecondaryItems(item);
            _loadStudentAlerts(item);
            $scope.linkButtons = getLinkButtons(item.type, $scope.customerCanEdit);

            $scope.showCodeLine = (item.type === 'school' || item.type === 'classroom');

            var urlIdentifier = getUrlIdentifier(item);
            $scope.studentLoginUrl = dblProductResourcesService.getStudentLoginUrl(item.district_url_identifier, urlIdentifier);
            $scope.schoolCode = dblProductResourcesService.getSchoolCode(item.district_url_identifier, urlIdentifier);
            if (edxFeatureFlagService.isClassroomLoginCodesEnabled()) {
              $scope.loginCode = item.login_code;
            }

            if (item.type === 'classroom') {
              dblStudentLoginCardReportService.init();
              var context = JSON.parse(localStorage.getItem('context')) || {};
              if(!context.group){
                rosterPromise = getStudents(item.id);
              }
            }
          });

          $rootScope.$on('$stateChangeSuccess', function (e) {
            $scope.schoolAdminChooserEnabled = false;
          });

          $rootScope.$on('leftPaneImageReady', function (e, image_url) {
            $scope.image_url = angular.copy(image_url);
          });

          //Bug 49784 -- This is a round-about way of adding a catch for the case when a school admin chooses
          //             to view classrooms, but G2 returns a 404.  This would happen if the teacher has classroom(s)
          //             assigned in Product, but in G2 the teacher does not.
          $rootScope.$on('requestRejected', function (e, rejection) {
            if (!$scope.schoolAdminChooserEnabled &&
              customer &&
              customer.school_admin_mode === 2 &&
              rejection && rejection.status === 404 &&
              rejection.config && rejection.config.url &&
              rejection.config.url.match(/\/n\/districts\/\d+\/classrooms/)) {

              $scope.schoolAdminChooserEnabled = true;
              $rootScope.$broadcast('genericAlert', {
                code: ERROR_CODES.ADMIN_NO_CLASSROOMS_IN_G2,
                type: "warning",
                apiError: rejection.data.apiError,
                suggest_refresh: true
              });
            }
          });

          function onClickCog() {
            $analytics.eventTrack('Edit Button', {
              category: 'Settings',
              label: $scope.item.type + '-' + $scope.item.id
            });
            if ($scope.item.provision_uid !== null && typeof $scope.item.provision_uid !== 'undefined') {
              navigateToSettingsForItem();
            } else {
              var rejection = {
                object_type: $scope.item.type,
                object_id: $scope.item.id
              };
              $rootScope.$broadcast('editModeBlocked', rejection);
            }
          }

          $scope.onClickCog = onClickCog;

          function onClickParentLetter() {
            $scope.$emit('familyInvitationLettersModal');
          }

          function onClickLoginCards() {
            if (rosterPromise) {
              var childScope = $scope.$new();

              rosterPromise.then(function () {
                dblStudentLoginCardReportService.print(childScope);
              });
            }
          }

          function onClickClassroomCodes() {
            dblClassroomCodePrintService.printClassroomCodesForSchool($state.params.districtId, $state.params.schoolId);
          }

          function getStudents(cid) {
            return settingsApi.getClassroomRoster(cid, function(data) {
              $scope.authTypeIsText = data.authentication_type === 2;
              $scope.activatedStudents = _.filter(data.students, function (student) {
                return student.activated;
              });
            }).$promise;
          }

          $scope.assignModeService = $assignMode;


          $scope.setLoaded = function () {
            $scope.imageLoading = false;
          };

          $scope.$on('$destroy', function () {
            itemSubscription.dispose();
          });

        }
      ]
    };
  });
